import { razorpay } from './razorpay'

/**
 * Registered gateway drivers, keyed by the upstream `gateway_name`.
 * Every driver implements:
 *   key: string
 *   pay({ order, verifyContext, sessionUser, onSuccess, onFailure }): Promise
 *
 * To support a new gateway (stripe, …) add its driver module here —
 * the cart page needs no changes.
 */
const GATEWAYS = {
  [razorpay.key]: razorpay,
}

/** Gateway identifier from a /payment-gateways row: "razorpay", "cod", … */
export const gatewayKey = (g) => String(g?.gateway_name ?? g?.slug ?? g?.id ?? '').toLowerCase()

/** Driver for the chosen gateway, or null when not (yet) supported. */
export const getGatewayDriver = (g) => GATEWAYS[gatewayKey(g)] ?? null
